import React from 'react'
import common from '../../../assets/common.jpg'
import MegaNavbar from '../../../Components/MegaNavbar'

import DrSanaTabassum_Cv  from '../../../assets/F_Social_science_Cv/Education/DrSanaTabassum_Cv.pdf'
import DRAbidaSultana_CV from '../../../assets/F_Social_science_Cv/Education/DRAbidaSultana_CV.pdf'
import DrSHAHZADI_Cv from '../../../assets/F_Social_science_Cv/Education/DrSHAHZADI SEEMA_CV.pdf'
import DrUzmaRehman_CV from '../../../assets/F_Social_science_Cv/Education/DrUzmaRehman_CV.pdf'
import DrWilayatBibi_CV from '../../../assets/F_Social_science_Cv/Education/DrWilayatBibi_CV.pdf'


import Footer from '../../../Components/Footer'

const Education = () => {
  return (
    <>
    
    <MegaNavbar/>
     <section id="team" className="team section-bg">
        <div className="container">

      <div className="section-title">
        <h2>Education</h2>
        
        <p>Faculty of Education.</p>
      </div>

      <div className="row">

      <div className="col-lg-6">
          <div className="member d-flex align-items-start">
            <div className="teampic"><img src={common} className="img-fluid" alt="" /></div>
            <div className="member-info">
              <h4>  Dr. Abida Sultana  </h4>
              <span>Lecturer Department of Education </span>
              <p>Lecturer Department of Education Shaheed Benazir Bhutto Women University Peshawar </p>
                 <p className='my-icon'><i className="bi bi-envelope-at-fill"></i>   abidasultana@sbbwu.edu.pk   </p>
              <div className="social">
                <a href={DRAbidaSultana_CV}><i class="bi bi-file-earmark-person-fill"></i></a>
                <a href=""><i className="bi bi-google"></i></a>
                <a href=""><i className="bi bi-linkedin"></i></a>
               </div>
            </div>
          </div>
        </div>
      <div className="col-lg-6">
          <div className="member d-flex align-items-start">
            <div className="teampic"><img src={common} className="img-fluid" alt="" /></div>
            <div className="member-info">
              <h4>   Dr. Sana Tabassum </h4>
              <span>Lecturer Department of Education </span>
              <p>Lecturer Department of Education Shaheed Benazir Bhutto Women University Peshawar </p>
                 <p className='my-icon'><i className="bi bi-envelope-at-fill"></i> sanatabassum@sbbwu.edu.pk   </p>
              <div className="social">
                <a href={DrSanaTabassum_Cv}><i class="bi bi-file-earmark-person-fill"></i></a>
                <a href=""><i className="bi bi-google"></i></a>
                <a href=""><i className="bi bi-linkedin"></i></a>
               </div>
            </div>
          </div>
        </div>
 

 
      <div className="col-lg-6">
          <div className="member d-flex align-items-start">
            <div className="teampic"><img src={common} className="img-fluid" alt="" /></div>
            <div className="member-info">
              <h4> Dr. Shahzadi Seema   </h4>
              <span>Lecturer Department of Education </span>
              <p>Assistant Professor, Department of Education Shaheed Benazir Bhutto Women University Peshawar </p>
                 <p className='my-icon'><i className="bi bi-envelope-at-fill"></i>   shahadi.seema@sbbwu.edu.pk  </p>
              <div className="social">
                <a href={DrSHAHZADI_Cv}><i class="bi bi-file-earmark-person-fill"></i></a>
                <a href=""><i className="bi bi-google"></i></a>
                <a href=""><i className="bi bi-linkedin"></i></a>
               </div>
            </div>
          </div>
        </div>
 
      <div className="col-lg-6">
          <div className="member d-flex align-items-start">
            <div className="teampic"><img src={common} className="img-fluid" alt="" /></div>
            <div className="member-info">
              <h4>  Dr. Wilayat Bibi  </h4>
              <span>Associate Professor Department of Education </span>
              <p>Associate Professor Department of Education Shaheed Benazir Bhutto Women University Peshawar </p>
                 <p className='my-icon'><i className="bi bi-envelope-at-fill"></i> wilayat.bibi@sbbwu.edu.pk  </p>
              <div className="social">
                <a href={DrWilayatBibi_CV}><i class="bi bi-file-earmark-person-fill"></i></a>
                <a href=""><i className="bi bi-google"></i></a>
                <a href=""><i className="bi bi-linkedin"></i></a>
               </div>
            </div>
          </div>
        </div>
      <div className="col-lg-6">
          <div className="member d-flex align-items-start">
            <div className="teampic"><img src={common} className="img-fluid" alt="" /></div>
            <div className="member-info">
              <h4>  Dr. Uzma Rehman Khattak   </h4>
              <span>Lecturer Department of Education </span>
              <p>Lecturer Department of Education Shaheed Benazir Bhutto Women University Peshawar </p>
                 <p className='my-icon'><i className="bi bi-envelope-at-fill"></i> Uzmarehman@sbbwu.edu.pk </p>
              <div className="social">
                <a href={DrUzmaRehman_CV}><i class="bi bi-file-earmark-person-fill"></i></a>
                <a href=""><i className="bi bi-google"></i></a>
                <a href=""><i className="bi bi-linkedin"></i></a>
               </div>
            </div>
          </div>
        </div>
 

 
 

        {/* Repeat the above structure for other team members */}

      </div>

    </div>
  </section>
      <Footer/>      
 

    </>
  )
}

export default Education
